module.exports = __webpack_public_path__ + "img/products_6.bc99ab02.png";